import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";
import Loading from "@/atomic/atoms/Loading";
import { getFormattedValue } from "@/utils/functions";
import FilterModal from "@/atomic/atoms/FilterModal";
import LoggedMenu from "@/atomic/atoms/LoggedMenu";

export default function WalletView({
  items,
  isLoading,
  goBack,
  goToRecharge,
  balance,
  isVisibleFilter,
  toggleFilterModal,
  selectedFilter,
  setSelectedFilter,
  filter,
  isShowingMenu,
  toggleMenu,
  refresh,
}: PropsView) {
  return (
    <div className="relative flex flex-1 flex-col w-full">
      <Header 
        title="Carteira"
        hasLeftButton
        goBack={goBack} 
        rightButton={
          !isShowingMenu ? <button onClick={toggleMenu} className="flex flex-row items-center">
            <img 
              src={"/icon-profile.png"}
              width={20}
              height={20}
              alt="iStock"
              className="mr-2"
            />
            Perfil
          </button> : undefined
        } 
      />
      <div className="absolute flex w-full justify-center h-[calc(185px)]">
        <img 
          src={"/faixa_topo_1440.jpg"}
          width={1505}
          height={185}
          alt="iStock"
          className="absolute brightness-50 h-[calc(185px)] object-cover w-full max-w-[calc(900px)] object-top"
        />
      </div>
      <main className="p-1 z-10 p-2 w-full flex justify-center h-full text-black h-form">
        <article className="h-full flex flex-col w-[calc(480px)]">
          <div className="w-full">
            <div className="mt-4 bg-transparent border border-1 border-white rounded-lg w-full">
              <div className="flex flex-row w-full p-4 items-center justify-between">
                <div>
                  <p className="text-white text-sm">Total da carteira</p>
                  <p className="text-white text-lg">{balance}</p>
                </div>
                <button className="bg-gray-800 border border-1 border-principal bg-principal rounded-lg text-black p-2 px-4" onClick={goToRecharge}>
                  Recarga
                </button>
              </div>
            </div>
            <div className="flex w-full justify-between mt-3">
              <button type="button" onClick={refresh}>
                <img
                  alt="Atualizar"
                  height={30}
                  width={30}
                  src="/icon-refresh.png"
                />
              </button>
              <button onClick={toggleFilterModal} className="flex flex-row items-center text-sm">
                <img 
                  src={"/icon-filter.png"}
                  width={24}
                  height={24}
                  alt="icon car"
                  className="mr-1"
                />
                FILTRAR
              </button>
            </div>
            <div className="w-full mt-4">
              {!isLoading && items?.length === 0 && <div className="mt-5 flex flex-col w-full items-center justify-center">
                <img 
                  src={"/icon-car-front-close.png"}
                  width={60}
                  height={60}
                  alt="icon car"
                  className="mr-1"
                />
                <h2 className="mt-2 text-base text-gray-500 text-center">Nenhuma recarga realizada.</h2>
              </div>}
              {!isLoading && items?.map((item, index) => {
                  let date = item?.releaseDateHistory;
                  let hour = date?.split('T')?.[1];
                  date = date?.split('T')?.[0];
                  date = `${date?.split('-')?.[2]}/${date?.split('-')?.[1]}/${date?.split('-')?.[0]} - ${hour}`;
                  return (
                    <div className="w-full" key={index}>
                      <div className="w-full">
                        <p className="text-base">Recarga realizada</p>
                        <div className="mt-1 w-full flex flex-row items-center justify-between">
                          <p className="text-sm">{date}</p>
                          <p className="text-base font-bold">{getFormattedValue(Number(item?.entryValue) * -1)}</p>
                        </div>
                      </div>
                      <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
                    </div>
                  );
              })}
            </div>
          </div>
        </article>
      </main>
      <LoggedMenu 
        isShowingMenu={isShowingMenu}
        toggleMenu={toggleMenu}
      />
      {isVisibleFilter && <FilterModal
        toggleModal={toggleFilterModal}
        selectedFilter={selectedFilter}
        setSelectedFilter={setSelectedFilter}
        filter={filter}
      />}
      {isLoading && <Loading />}
    </div>
  );
}
